/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCharterFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type Charter, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter/GetFinancialData
 */
export interface GetFinancialDataRequestBuilder extends BaseRequestBuilder<GetFinancialDataRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Charter[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<GetFinancialDataRequestBuilderGetQueryParameters> | undefined) : Promise<Charter[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<GetFinancialDataRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface GetFinancialDataRequestBuilderGetQueryParameters {
    aircraftTypeId?: number;
    clientId?: number;
    flightNumber?: string;
    flightType?: string;
    isFerry?: boolean;
    month?: number;
    route?: string;
    seasonId?: number;
    status?: string;
    year?: number;
}
/**
 * Uri template for the request builder.
 */
export const GetFinancialDataRequestBuilderUriTemplate = "{+baseurl}/Charter/GetFinancialData?aircraftTypeId={aircraftTypeId}&clientId={clientId}&flightNumber={flightNumber}&flightType={flightType}&isFerry={isFerry}&month={month}&route={route}&seasonId={seasonId}&status={status}&year={year}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetFinancialDataRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: GetFinancialDataRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createCharterFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
